import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Schedule from '../common/Schedule';
import CompletedList from './CompletedList';
import SortBy from '../Results/SortBy';
import FilterBy from '../Results/FilterBy';
import { map, cloneDeep } from 'lodash';
import Button from '../common/Button';
import JobSliderView from '../JobSliderView/JobSliderView';
import InfiniteScroll from 'react-infinite-scroller';
import PageLoader from '../common/PageLoader';
import { imageBasePath } from '../../constants/staticData';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class CompletedJobs extends Component {
  constructor(props, context) {

    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    let currentPage = 0;
    let rowCount = undefined;

    if (props.jobRequestReducer.openJobsList.completedJobs.length) {
      currentPage = props.jobRequestReducer.nextPageInOpenJobs || 0;
      rowCount = props.jobRequestReducer.pageInfo.completedJobsTotalCount || 10;
    } else {
      rowCount = props.jobRequestReducer.openJobsList.completedJobs.length
    }
    this.isFetchingData = false;
    this.state = {
      searchMobile: false,
      filterParameters: false,
      sortKey: '',
      notificationVisible: false,
      showSidebar: false,
      currentPage: currentPage,
      rowCount: rowCount,
      currentSliderId: 0,
      vat: 0,
      showJobSlider: false,
      completedJobsLoading: !props.jobRequestReducer.completedJobsLoaded,
    };
    document.body.style.overflow = "visible";
    this.filterCompleted = this.filterCompleted.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
  }
  componentWillMount() {
    if (!this.props.jobRequestReducer.completedJobsLoaded) {
      this.props.actions.getOpenJobs(7, 10, 0, false, 'sortby=-date', this.state.filterParameters);
    }
    this.props.actions.getBusinessTax();
  }
  componentWillReceiveProps(nextProps) {


    console.log("jobRequestReducer.openJobsList",nextProps.jobRequestReducer.pageInfo)
    if (nextProps.jobRequestReducer.openJobsList.completedJobs.length) {
      this.isFetchingData = false;
      this.setState({
        currentPage: nextProps.jobRequestReducer.nextPageInOpenJobs,
        rowCount: nextProps.jobRequestReducer.pageInfo.completedJobsTotalCount,
        completedJobsLoading: !nextProps.jobRequestReducer.completedJobsLoaded
      });
    } else {
      this.setState({ rowCount: nextProps.jobRequestReducer.openJobsList.completedJobs.length, completedJobsLoading: !nextProps.jobRequestReducer.completedJobsLoaded });
    }
    this.setState({

      vat:  nextProps.commonReducer && nextProps.commonReducer.taxInfo &&  nextProps.commonReducer.taxInfo.length && nextProps.commonReducer.taxInfo ?  nextProps.commonReducer.taxInfo[0].value: 0,
    })
  }
  componentWillUnmount(){
    document.body.style.overflow = "visible";
  }
  sortChanged(selectedOption, sortState) {
    let sortKey = this.state.sortKey;
    if (selectedOption == "Nearest First") {
      sortKey = 'sortby=-distance';
    } else if (selectedOption == "Farthest First") {
      sortKey = 'sortby=distance';
    } else if (selectedOption == "Newest to Oldest") {
      sortKey = 'sortby=-date';
    } else if (selectedOption == "Oldest to Newest") {
      sortKey = 'sortby=date';
    }
    this.props.actions.getOpenJobs(7, 10, 0, false, sortKey);
    let updatedSortState = cloneDeep(sortState);
    updatedSortState.sortByText = selectedOption;
    updatedSortState.sortBy = false;
    this.props.actions.openJobsFilterChanged(updatedSortState, 'completed', true);
    this.setState({ sortKey: sortKey });
  }
  filterCompleted(queryParams, filterState) {
    this.setState({ filterParameters: queryParams });
    let updatedFilterState = cloneDeep(filterState);
    updatedFilterState.filterParams = queryParams;
    updatedFilterState.fiterBy = false;
    this.props.actions.openJobsFilterChanged(updatedFilterState, 'completed');
    this.props.actions.getOpenJobs(7, 10, 0, false, this.state.sortKey, queryParams);
  }
  toggleNotification(isVisible) {
    this.setState({ 'notificationVisible': isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar })
  }
  render() {
    const { jobRequestReducer, actions, commonReducer } = this.props;


    console.log("jobRequestReducer.openJobsFilters.completed.sort",jobRequestReducer.openJobsFilters.completed);
    return (

      <div>
        {/*Header*/}
        <Header searchMobile={this.state.searchMobile} hideOption={() => this.setState({ searchMobile: true })} commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification} authReducer={this.props.authReducer}
          hCallback={() => { this.hclickCallBack() }} router={this.props.router} />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar showSidebar={this.state.showSidebar} router={this.props.router} actions={this.props.actions} commonReducer={this.props.commonReducer} authReducer={this.props.authReducer} />
          <div className="container-fluid main-container">
            {this.state.completedJobsLoading
              ?
              <div className="col-md-9 mpad0 padr30">
                <PageLoader />
              </div>
              :
              <div className="col-md-9 mpad0 padr30">
                <div className="ov-heading">
                  <div className="text-dropdown statusList-dropdown">
                    <h4 className="oj-title">{commonReducer.jobCount && commonReducer.jobCount.completed ? commonReducer.jobCount.completed + " Completed" : this.state.rowCount != undefined ? this.state.rowCount ? this.state.rowCount + " Completed" : "0 Completed" : ''}</h4>
                  </div>
                  {this.state.rowCount || (!this.state.rowCount && (this.state.filterParameters || (jobRequestReducer.openJobsFilters.completed && jobRequestReducer.openJobsFilters.completed.filter && jobRequestReducer.openJobsFilters.completed.filter.filterParams))) ? <div className="filter-section">
                    <SortBy sortCallback={this.sortChanged} sortState={jobRequestReducer.openJobsFilters && jobRequestReducer.openJobsFilters.completed && jobRequestReducer.openJobsFilters.completed.sort} />
                    <FilterBy actions={actions} jobRequestReducer={jobRequestReducer} filterCompleted={this.filterCompleted.bind(this)} filterState={jobRequestReducer.openJobsFilters && jobRequestReducer.openJobsFilters.completed && jobRequestReducer.openJobsFilters.completed.filter} />
                    <span className="map-icon">
                      <a href="">
                        <i className="mdi mdi-map" />
                        <label>Map</label>
                        <i className="mdi mdi-chevron-down" />
                      </a>
                    </span>
                  </div> : <div />}
                </div>
                {this.state.rowCount ? <div className="content-view">
                  <div className="applied-wrapper">
                    <div className="result-category">
                      <div className="status-heading mhide">
                        <ul className="list-unstyled completed-header" >
                          <li className="request-date">Request Date</li>
                          <li className="status-data">STATUS</li>
                          <li className="quote-data">QUOTE</li>
                          <li className="model-data">MODEL / DETAILS</li>
                          <li className="area-data">PAYMENT MODE</li>
                        </ul>
                      </div>
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={() => {
                          if (!this.isFetchingData) {
                            this.isFetchingData = true;
                            actions.getOpenJobs(7, 10, this.state.currentPage, true, this.state.sortKey ? this.state.sortKey : 'sortby=-date', this.state.filterParameters);
                          }
                        }}
                        hasMore={jobRequestReducer.openJobsList.completedJobs.length < this.state.rowCount}
                        loader={<PageLoader />}>
                        {jobRequestReducer.openJobsList.completedJobs && jobRequestReducer.openJobsList.completedJobs.length ? map(jobRequestReducer.openJobsList.completedJobs, (completedData, key) => {
                            return (
                              <CompletedList
                                router={this.props.router}
                                onCardClick={(currentSliderId) => {
                                  this.setState({'showJobSlider': true, 'currentSliderId': currentSliderId})
                                  document.body.style.overflow = "hidden";
                                  //document.body.style.position = "fixed";
                                }}
                                allData={jobRequestReducer.openJobsList.completedJobs}
                                data={completedData}
                                jobStatus="completed"
                                vat={this.state.vat}
                                key={key}/>
                            );
                           }) : <div />}
                      </InfiniteScroll>
                    </div>
                  </div>
                </div> : <div className="content-view"> <div className="empty-state-holder"><span className="empty-state-content"><img src={`${imageBasePath}/request_empty.png`} /><span>Oops! Looks like there aren’t any Jobs in Completed </span></span></div></div>}
                {this.state.showJobSlider && <JobSliderView
                  commonReducer={this.props.commonReducer}
                  jobRequestReducer={this.props.jobRequestReducer}
                  jobs={jobRequestReducer.openJobsList.completedJobs}
                  actions={this.props.actions}
                  currentSliderId={this.state.currentSliderId}
                  jobStatus="completed"
                  router={this.props.router}
                  modalCloseCallBack={(e) => {
                    e.preventDefault();
                    this.setState({ 'showJobSlider': false });
                    document.body.style.overflow = "visible";
                    }} />}
              </div>
            }
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
            </div>
          </div>
        </div>
        {this.state.searchMobile && <div >

          <MobileHeaderSearch mobile={true} actions={this.props.actions} commonReducer={this.props.commonReducer} mobSearchClick={() => this.setState({ searchMobile: false })} />
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusList/CompletedJobs.jsx